import { render, staticRenderFns } from "./FnbBankForm.vue?vue&type=template&id=79e1255b"
import script from "./FnbBankForm.vue?vue&type=script&lang=js"
export * from "./FnbBankForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports